import React from "react";
import { mobileIs } from "../../../utils/siteUtils";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import Videojs from "../../video-js";
import classNames from "classnames";

const MediaCollectionRows = props => {
  const { image, imageMobile, video, videoMobile ,title, titleMobile, des, desMobile, titleSize } = props.data
  const index = props.index
  const isMobile = mobileIs();
	let videoOptions = 
		(( !isMobile && video && video.value) || ( isMobile && videoMobile && videoMobile.value))
			? {
					sources: [
					{
							src: isMobile ? videoMobile.value.src : video.value.src,
							type: isMobile ? videoMobile.value.mimeType : video.value.mimeType
					}
					],
					poster: isMobile ? imageMobile.value.src : image.value.src,
					videoTitle: '',
					autoplay: false,
					controls: true,
					muted: true
			}: null;
    
	let size = titleSize ? titleSize?.fields?.phrase?.value : "default";
  return (
		<>
			<div className="c-media-collection__models-item-layout grid">
				<div className="c-media-collection__models-item-content">
					<div className={classNames("media",{'video':videoOptions})}>
						{ !videoOptions && <img src={isMobile? imageMobile.value.src : image.value.src}/> }
						{ videoOptions && <Videojs {...videoOptions}  id={'videoMediaModel'+index} />}
					</div>
					<div className="detail">
          				{ ((isMobile && titleMobile.value) || (!isMobile && title.value)) &&
							<RichText tag="div" className={classNames("title __ff-lk-tp-b type-h1",size)} field={ isMobile ? titleMobile : title} />
						}
						{ ((isMobile && desMobile) || (!isMobile && des)) &&
							<RichText tag="div" className={classNames("des")} field={ isMobile ? desMobile : des} /
						>}
					</div>
				</div>
			</div>
		</>
  )
};
export default MediaCollectionRows;
